export default __webpack_public_path__ + "static/media/tv.36c9faa3.png";